import _slicedToArray from "E:\\Agents\\Agent-04\\_work\\53\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import { useState, useEffect } from 'react';
import throttle from 'lodash/throttle';
export function useStickyNav(stickyBreakpointTop, stickyBreakpointBottom, mainNav) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    sticky = _useState2[0],
    setSticky = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    navVisible = _useState4[0],
    setNavVisible = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    pageScrolled = _useState6[0],
    setPageScrolled = _useState6[1];
  var _useState7 = useState(0),
    _useState8 = _slicedToArray(_useState7, 2),
    prevScrollY = _useState8[0],
    setPrevScrollY = _useState8[1];
  var handleNavigation = throttle(function () {
    /* Set scrolled state, to make transparent nav white */
    if (window.scrollY > 1) {
      setPageScrolled(true);
    } else {
      setPageScrolled(false);
    }
    if (window.scrollY <= stickyBreakpointTop) {
      setSticky(false);
      setNavVisible(false);
    } else if (window.scrollY > stickyBreakpointBottom) {
      setSticky(true);
      if (window.scrollY > prevScrollY) {
        // 'scroll down'
        setNavVisible(false);
      }
      if (window.scrollY < prevScrollY) {
        // 'scroll up'
        setNavVisible(true);
      }
    } else {}
    setPrevScrollY(window.scrollY);
  }, 100);
  useEffect(function () {
    if (typeof window === 'undefined') {
      return;
    }
    if (!mainNav) {
      return;
    }
    window.addEventListener('scroll', handleNavigation);
    return function () {
      window.removeEventListener('scroll', handleNavigation);
    };
  }, [handleNavigation, mainNav]);
  return {
    sticky: sticky,
    navVisible: navVisible,
    pageScrolled: pageScrolled
  };
}